<template>
  <div>
    <b-card
      v-if="rawData"
      class="shadow-sm border-0 raw-data-card"
    >
      <template #header>
        <h5 class="mb-0 raw-data-header">
          البيانات الخام
        </h5>
      </template>

      <!-- Landsurvey Order Section -->
      <div v-if="rawData.landsurveyOrder">
        <h6 class="mb-3 text-primary font-weight-bold section-title">
          بيانات طلب المساحة
        </h6>

        <!-- Desktop Table View -->
        <div class="d-none d-md-block">

          <b-table
            :items="landsurveyOrderItems"
            :fields="landsurveyOrderFields"
            responsive
            striped
            bordered
            small
            class="raw-data-table"
          >
            <template #cell(value)="data">
              <span v-if="data.value !== null && data.value !== undefined">
                {{ data.value }}
              </span>
              <span
                v-else
                class="text-muted"
              >--</span>
            </template>
          </b-table>
        </div>

        <!-- Mobile Card View -->
        <div class="d-md-none">
          <div
            v-for="(item, index) in landsurveyOrderItems"
            :key="index"
            class="data-item-mobile"
          >
            <div class="data-label-mobile">
              {{ item.label }}
            </div>
            <div class="data-value-mobile">
              <span v-if="item.value !== null && item.value !== undefined">
                {{ item.value }}
              </span>
              <span
                v-else
                class="text-muted"
              >--</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Citizen Survey Section -->
      <div v-if="rawData.citizenSurvey">
        <h6 class="mb-3 text-primary font-weight-bold section-title">
          بيانات استطلاع المواطن
        </h6>

        <!-- Desktop Table View -->
        <div class="d-none d-md-block">
          <b-table
            :items="citizenSurveyItems"
            :fields="citizenSurveyFields"
            responsive
            striped
            bordered
            small
            class="raw-data-table"
          >
            <template #cell(value)="data">
              <span v-if="data.value !== null && data.value !== undefined">
                {{ data.value }}
              </span>
              <span
                v-else
                class="text-muted"
              >--</span>
            </template>
          </b-table>
        </div>

        <!-- Mobile Card View -->
        <div class="d-md-none">
          <div
            v-for="(item, index) in citizenSurveyItems"
            :key="index"
            class="data-item-mobile mb-2"
          >
            <div class="data-label-mobile">
              {{ item.label }}
            </div>
            <div class="data-value-mobile">
              <span v-if="item.value !== null && item.value !== undefined">
                {{ item.value }}
              </span>
              <span
                v-else
                class="text-muted"
              >--</span>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="!rawData"
        class="text-center py-4"
      >
        <b-spinner variant="primary" />
        <p class="mt-2 text-muted">
          جاري تحميل البيانات...
        </p>
      </div>
    </b-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { BCard, BTable, BSpinner } from 'bootstrap-vue'

export default {
  name: 'RawDataComponent',
  components: {
    BCard,
    BTable,
    BSpinner,
  },
  computed: {
    projectId() {
      return this.$route.params.id
    },
    ...mapGetters('projects', ['rawData']),
    landsurveyOrderFields() {
      return [
        {
          key: 'label', label: 'الحقل', thClass: 'text-right', tdClass: 'font-weight-bold',
        },
        { key: 'value', label: 'القيمة', thClass: 'text-right' },
      ]
    },
    citizenSurveyFields() {
      return [
        {
          key: 'label', label: 'الحقل', thClass: 'text-right', tdClass: 'font-weight-bold',
        },
        { key: 'value', label: 'القيمة', thClass: 'text-right' },
      ]
    },
    landsurveyOrderItems() {
      if (!this.rawData?.landsurveyOrder) return []
      const data = this.rawData.landsurveyOrder
      return [
        { label: 'رقم الطلب', value: data.order_number },
        { label: 'رقم المشروع', value: data.project_id },
        { label: 'تم الإنشاء', value: data.is_created ? 'نعم' : 'لا' },
        { label: 'تاريخ التوزيع', value: this.formatDate(data.distribution_at) },
        { label: 'تاريخ الرفع المساحي/تاريخ المسح', value: this.formatDate(data.survey_date) },
        { label: 'الاسم', value: data.name },
        { label: 'الهاتف', value: data.phone },
        { label: 'نوع الوحدة', value: data.unit_type },
        { label: 'المساحة (م²)', value: data.area_m2 },
        { label: 'نوع المساحة', value: this.rawData?.citizenSurvey?.areatypetext },
        { label: 'المحافظة', value: data.governorate },
        { label: 'المركز', value: data.center },
        { label: 'القرية', value: data.village },
        { label: 'الشارع', value: data.street },
        { label: 'معالم', value: data.landmarks },
        { label: 'الفريق', value: data.team },
        { label: 'حالة الطلب', value: data.order_status },
        { label: 'حالة المراجعة', value: data.review_status },
        { label: 'اسم الشركة', value: data.company_name },
        { label: 'تاريخ الإنشاء', value: this.formatDate(data.created_at) },
        { label: 'تاريخ التحديث', value: this.formatDate(data.updated_at) },
      ]
    },
    citizenSurveyItems() {
      if (!this.rawData?.citizenSurvey) return []
      const data = this.rawData.citizenSurvey
      return [
        { label: 'رقم الطلب', value: data.requestnumber },
        { label: 'الاسم الكامل', value: data.arabicfullname },
        { label: 'رقم المشروع', value: data.project_id },
        { label: 'تم الإنشاء', value: data.is_created ? 'نعم' : 'لا' },
        { label: 'اسم الوحدة', value: data.unitname },
        { label: 'تاريخ الإضافة', value: this.formatExcelDate(data.addeddate) },
        { label: 'المحافظة', value: data.gov },
        { label: 'المركز', value: data.sec },
        { label: 'القرية', value: data.ssec },
        { label: 'كود المحافظة', value: data.gov_code },
        { label: 'رقم العقار', value: data.property_number },
        { label: 'رقم الطابق', value: data.floor_number },
        { label: 'اسم الشارع', value: data.streetname },
        { label: 'رقم الشقة', value: data.apartment_number },
        { label: 'علامة مميزة', value: data.unique_mark },
        { label: 'رقم الهاتف', value: data.telephonenumber },
        { label: 'معرف فريق المسح', value: data.survey_team_id },
        { label: 'تاريخ ووقت التكليف', value: this.formatExcelDate(data.assignment_date_time) },
        { label: 'تاريخ الاستحقاق', value: this.formatExcelDate(data.due_date) },
        { label: 'معرف الشركة', value: data.company_id },
        { label: 'اسم الشركة', value: data.companyname },
        { label: 'التأكيد', value: data.confirmed },
        { label: 'فئة المساحة', value: data.area_m_category },
        { label: 'حالة التوزيع', value: data.assign_status },
        { label: 'حالة توزيع الفريق', value: data.assign_team_status },
        { label: 'الشهادة', value: data.cert },
        { label: 'حالة مراجعة المسح', value: data.survey_review_status },
        { label: 'نوع المساحة', value: data.areatypetext },
        { label: 'حالة الرفع', value: data.collect_status },
        { label: 'معرف المركز', value: data.secid },
        { label: 'العنوان', value: data.address },
        { label: 'تاريخ الإنشاء', value: this.formatDate(data.created_at) },
        { label: 'تاريخ التحديث', value: this.formatDate(data.updated_at) },
      ]
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.$store.dispatch('projects/getRawData', {
        id: this.projectId,
      })
    },
    formatDate(dateString) {
      if (!dateString) return '--'
      try {
        const date = new Date(dateString)
        return date.toLocaleDateString('ar-EG', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        })
      } catch (e) {
        return dateString
      }
    },
    formatExcelDate(excelDate) {
      if (!excelDate) return '--'
      try {
        // Excel date serial number (days since 1900-01-01)
        // Excel epoch is December 30, 1899 (not January 1, 1900 due to leap year bug)
        const excelEpoch = new Date(1899, 11, 30)
        const serialNumber = parseFloat(excelDate)

        // Calculate days and fractional part (time)
        const days = Math.floor(serialNumber)
        const fractionalDay = serialNumber - days

        // Create date
        const date = new Date(excelEpoch)
        date.setDate(date.getDate() + days)

        // Add time portion (fractional day * 24 hours)
        const hours = Math.floor(fractionalDay * 24)
        const minutes = Math.floor((fractionalDay * 24 - hours) * 60)
        date.setHours(hours, minutes, 0, 0)

        return date.toLocaleDateString('ar-EG', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        })
      } catch (e) {
        return excelDate
      }
    },
  },
}
</script>
<style scoped>
.raw-data-card {
    padding: 0;
}

.raw-data-header {
    font-size: 1.25rem;
    padding: 1rem;
}

.section-title {
    font-size: 1rem;
    padding: 0.5rem 0;
}

/* Desktop Table Styles */
.raw-data-table {
    font-size: 0.875rem;
    margin-bottom: 0;
}

.raw-data-table ::v-deep th {
    background-color: #f8f9fa;
    font-weight: 600;
    white-space: nowrap;
}

.raw-data-table ::v-deep td {
    vertical-align: middle;
    word-break: break-word;
    max-width: 300px;
}

.raw-data-table ::v-deep td:last-child {
    max-width: none;
}

/* Mobile Card View Styles */
.data-item-mobile {
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    padding: 0.75rem;
    transition: background-color 0.2s;
}

.data-item-mobile:nth-child(even) {
    background-color: #ffffff;
}

.data-label-mobile {
    font-weight: 600;
    font-size: 0.8rem;
    color: #495057;
    margin-bottom: 0.5rem;
    padding-bottom: 0.25rem;
    border-bottom: 1px solid #e9ecef;
}

.data-value-mobile {
    font-size: 0.875rem;
    color: #212529;
    word-break: break-word;
    line-height: 1.5;
    padding-right: 0.5rem;
}

/* Mobile Responsive Styles */
@media (max-width: 767.98px) {
    .raw-data-card {
        margin: 0 -0.5rem;
        border-radius: 0;
    }

    .raw-data-header {
        font-size: 1.1rem;
        padding: 0.75rem;
    }

    .section-title {
        font-size: 0.95rem;
        padding: 0.5rem 0.75rem;
        margin-bottom: 0.75rem !important;
    }

    .raw-data-table {
        font-size: 0.7rem;
    }

    .raw-data-table ::v-deep th,
    .raw-data-table ::v-deep td {
        padding: 0.4rem 0.25rem;
        font-size: 0.7rem;
    }

    .raw-data-table ::v-deep th {
        font-size: 0.7rem;
    }

    .data-item-mobile {
        padding: 0.625rem;
        margin-bottom: 0.5rem;
    }

    .data-label-mobile {
        font-size: 0.75rem;
        margin-bottom: 0.375rem;
    }

    .data-value-mobile {
        font-size: 0.8rem;
    }
}

/* Extra Small Devices */
@media (max-width: 575.98px) {
    .raw-data-header {
        font-size: 1rem;
        padding: 0.625rem;
    }

    .section-title {
        font-size: 0.9rem;
        padding: 0.5rem 0.625rem;
    }

    .data-item-mobile {
        padding: 0.5rem;
    }

    .data-label-mobile {
        font-size: 0.7rem;
    }

    .data-value-mobile {
        font-size: 0.75rem;
    }
}

/* Ensure proper scrolling on mobile */
@media (max-width: 767.98px) {
    .raw-data-table ::v-deep .table-responsive {
        -webkit-overflow-scrolling: touch;
    }
}
</style>
